import { useState, useCallback } from "react";
import ConfirmDialog from "./ConfirmDialog";

export function useConfirm() {
  const [state, setState] = useState(null);

  const confirm = useCallback(
    (opts) => new Promise((resolve) => {
      setState({ confirmLabel: "Confirm", danger: false, ...opts, resolve });
    }),
    []
  );

  const close = (result) => {
    setState((s) => { s?.resolve(result); return null; });
  };

  const dialog = (
    <ConfirmDialog
      open={!!state}
      onOpenChange={(o) => { if (!o) close(false); }}
      title={state?.title || ""}
      message={state?.message || ""}
      confirmLabel={state?.confirmLabel || "Confirm"}
      danger={state?.danger}
      onConfirm={() => close(true)} />
  );

  return { confirm, dialog };
}
